import request from "../../request";
let path = 'SportRecord/menu'
export default {
    menu:(method = 'get', params)=> request.req(`${path}/save`,method,params),
}